import Tiers from './tiers';
import Contact from './contact';
import Reseau from './reseau';

export default [...Tiers, ...Contact, ...Reseau];
